import React from "react";
import { Link } from "react-router-dom";
import { SVGIcons, ImgIcons } from "../../Helpers/Common";
import $ from "jquery";
import * as CountryCode from "../../Config/CountryCode.js";
import { color, motion } from "framer-motion";
import Slider from "react-slick";
import "./Signup.css";
import { Footerdesk } from "../../components/FooterDesk/Footerdesk";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Pagination, Autoplay } from "swiper";
import { isMobile } from "react-device-detect";
import Maintenance from "../signup/Maintenance";
import { FooterMobile } from "../FooterDesk/FooterMobile.js";
import videojs from 'video.js';
import { Getotp } from "../../Model/Users.js";
import HeaderEth from "../common/HeaderEth.js";
import FooterEth from "../common/FooterEth.js";

var ImageData = "";
var SVGIcon = "";
ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));

class Signupscreen1 extends React.Component {
  constructor(props) {
    super(props);
    this.videoRef = React.createRef();
    this.state = {
      showControls: false,
      player: undefined
    };
    this.playerRef = React.createRef();
  }

  componentWillUnmount() {
    const { player } = this.state;
    if (player) player.dispose();
  }

  hideshow() {
    $(".temp3-item .temp3-head")
      .unbind()
      .click(function () {
        var activeTitle = $(this).hasClass("temp3Active");
        $(".temp3-item .temp3-head")
          .removeClass("temp3Active")
          .siblings(".temp3-content")
          .slideUp();
        if (!activeTitle) {
          $(this).addClass("temp3Active").next(".temp3-content").slideDown();
        }
      });
  }

  render() {
    var Signupscreen1State = this.state;
    const settings = {
      centerMode: true,
      centerPadding: "60px",
      autoplay: true,
      slidesToShow: 3,
      responsive: [
        // {
        //   breakpoint: 800,
        //   settings: {
        //     arrows: false,
        //     centerMode: true,
        //     // centerPadding: "40px",
        //     slidesToShow: 1,
        //   },
        // },
        {
          breakpoint: 700,
          settings: {
            arrows: false,
            centerMode: true,
            // centerPadding: "40px",
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 650,
          settings: {
            slidesToShow: 1,
            dots: true,
            arrows: false,
            centerMode: false,
            centerPadding: "40px",
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 850,
          settings: {
            slidesToShow: 1,
            dots: true,
            arrows: false,
            centerMode: false,
            centerPadding: "40px",
            slidesToShow: 1,
          },
        },
      ],
    };
    this.state = this.props.data.state;
    var CheckVirsionResponse = JSON.parse(this.props.data.state.VirsionCheckData.data).data;
    var Step3Data = JSON.parse(this.props.data.state.VirsionCheckData.data).data.banner_images.signup_steps_three;
    var FaqData = JSON.parse(this.props.data.state.Faqdata.data.body);
    this.handleChange = this.props.data.handleChange;
    this.isSignUpExist = this.props.data.isSignUpExist;
    this.isSignInExist = this.props.data.isSignInExist;
    this.showButton = this.props.data.state.showButton;

    if ((this.state.isValidEmail && this.state.isValidPassword) || (this.state.isValidMobile && this.state.isValidPassword)
    ) {
      var enable = false;
    } else {
      var enable = true;
    }
    if (this.state.fields.fld_email && this.state.fields.fld_email.length > 0) {
      var fld_email = false;
      var fld_mobile = true;
    } else if (
      this.state.fields.fld_mobile &&
      this.state.fields.fld_mobile > 0
    ) {
      var fld_email = true;
      var fld_mobile = false;
    } else {
      var fld_email = false;
      var fld_mobile = false;
    }

    if (this.state.isValidPassword) {
      var fenable = false;
      if (this.state.isValidPassword) {
        var fenable = false;
      } else {
        var fenable = true;
      }
    } else {
      var fenable = true;
    }
    const maintenance = true;
    var mobilestate = this.state.fields.fld_mobile;
    // const { isVideoPlaying } = this.state;
    const { showControls } = this.state;

    return (
      <motion.div
        className="signup-eth"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      // transition={{ duration: 1 }}
      >
        <HeaderEth />
        <div className="signupnewcontainer">
          <div className="Container-signup">
            <h1>To Subscribe:</h1>
            <h2>Send A to 9012 to Subscribe Daily Plan</h2>
            <h2>Send B to 9012 to Subscribe Weekly Plan</h2>
            <Link to={"/subscribe"}>
              <h3>To Subscribe by telebirr, click here:</h3>
            </Link>
          </div>
          <div className="temp2">
            <p className="text" style={{ marginTop: "8px" }}>Already subscribed?</p>
            <div className="temp1Inner">
              <div
                className={
                  this.state.errors.isValidMobileerror
                    ? " formField error-border data formfieldone"
                    : fld_mobile
                      ? "formField data disable-fild formfieldone"
                      : "formField data formfieldone"
                }
                ref={this.emailInput}
              >
                {/* <select
                      name="country_code"
                      // onChange={this.handleChange}
                      className="selectTel1"
                      disabled={fld_mobile}
                    > */}
                {/* {CountryCode.Countrycode.map((CoutryData) => {
                  return (
                    <option
                      key={CoutryData.name}
                      value={CoutryData.dial_code}
                      style={{ width: "70px", textAlign: "center" }}
                    >
                      {CoutryData.dial_code}
                    </option>
                  );
                })} */}
                +251
                {/* </select> */}
                <div class="Form-line">|</div>
                <input
                  name="fld_mobile"
                  type="tel"
                  className="inputTel"
                  placeholder="Enter your mobile number"
                  value={this.state.fields.fld_mobile}
                  onChange={this.handleChange}
                  disabled={fld_mobile}
                  textcontenttype="none"
                  minLength="9"
                  maxLength="10"
                  autoCorrect="false"
                  autoComplete="off"
                  pattern="[0-9]"
                // required
                />
              </div>
              {/* {this.state.errors.isValidMobileerror ? (
                  <div className="error ethio-msg">
                    <img src={SVGIcon["error.svg"]} alt="DocuBay" />
                    <p>{this.state.msg.alreadyRegiter} </p>
                  </div>
                ) : null} */}

              {this.state.NumberNotFound ? (
                <div className="error ethio-msg">
                  <img
                    src={
                      process.env.PUBLIC_URL + "img/svg/error.svg"
                    }
                    alt="DocuBay"
                  />
                  <p>{this.state.NumberNotFoundMsg} </p>
                </div>
              ) : null}

              <div className="forgot-Pass" onClick={(e) => {
                e.preventDefault();
                this.props.data.GetOTP();
              }} >
                <button className="Get-otp-text">
                  Get OTP
                </button>
              </div>

              <div className="formField">
                <input
                  type="text"
                  name="otp"
                  id="otp"
                  className={
                    this.state.errors.isValidPassworderror
                      ? "password-hidden error-border"
                      : "password-hidden"
                  }
                  placeholder="Enter OTP"
                  // className="password-hidden"
                  value={this.state.fields.otp}
                  onChange={this.handleChange}
                  autoComplete="one-time-code"
                  // onFocus={() => {
                  //   this.props.data.handleFocus();
                  // }}
                  minLength="4"
                  maxLength="4"
                />
              </div>

              {this.state.otperror ? (
                <div className="error ethio-msg">
                  <img
                    src={
                      process.env.PUBLIC_URL + "img/svg/error.svg"
                    }
                    alt="DocuBay"
                  />
                  <p>{this.state.otpErrorMsg} </p>
                </div>
              ) : null}

              {this.state.userNotFound ? (
                <div className="error success-msg ethio-msg">
                  <p>{this.state.OTPsuccess} </p>
                </div>
              ) : null}

              {this.state.NotSubscribed ? (
                <div className="error ethio-msg">
                  <img
                    src={
                      process.env.PUBLIC_URL + "img/svg/error.svg"
                    }
                    alt="DocuBay"
                  />
                  <p>{this.state.NotSubscribed} </p>
                </div>
              ) : null}

              {this.state.OtpNotFound ? (
                <div className="error ethio-msg">
                  <img
                    src={
                      process.env.PUBLIC_URL + "img/svg/error.svg"
                    }
                    alt="DocuBay"
                  />
                  <p>{this.state.OtpNotFoundMsg} </p>
                </div>
              ) : null}

              {this.state.invalidOTP ? (
                <div className="error ethio-msg">
                  <img
                    src={
                      process.env.PUBLIC_URL + "img/svg/error.svg"
                    }
                    alt="DocuBay"
                  />
                  <p>{this.state.invalidOTPMsg} </p>
                </div>
              ) : null}

              {this.state.MaxLogin ? (
                <div className="error ethio-msg">
                  <img
                    src={
                      process.env.PUBLIC_URL + "img/svg/error.svg"
                    }
                    alt="DocuBay"
                  />
                  <p>{this.state.MaxLoginMsg} </p>
                </div>
              ) : null}
              {this.state.NotSubscribe ? (
                <div className="error ethio-msg">
                  <img
                    src={
                      process.env.PUBLIC_URL + "img/svg/error.svg"
                    }
                    alt="DocuBay"
                  />
                  <p>{this.state.NotSubscribeMsg} </p>
                </div>
              ) : null}

              {this.state.invalidData ? (
                <div className="error ethio-msg">
                  <img
                    src={
                      process.env.PUBLIC_URL + "img/svg/error.svg"
                    }
                    alt="DocuBay"
                  />
                  <p>{this.state.invalidDataMsg} </p>
                </div>
              ) : null}
              <div className="formField">
                <button
                  type="submit"
                  className={"btn-red"}
                // style={{ marginTop: "12px" }}
                >
                  Login
                </button>
              </div>
            </div>
          </div>
        </div>
        <FooterEth />
      </motion.div>
    );
  }
}
export default Signupscreen1;